import { useMemo } from 'react';
import useStepIndexFromConditions from '@fingo/lib/hooks/useStepIndexFromConditions';

const useAvailableFactoringTutorial = (stepsConditions = [], stepsCallbacks = {}) => {
  const steps = useMemo(
    () => [
      {
        id: 'select-invoices-step',
        title: 'Selecciona y cotiza tus facturas',
        description: '',
        onBack: () => {},
      },
      {
        id: 'evaluate-and-wait-step',
        title: 'Evaluar y esperar',
        description: '',
        onBack: stepsCallbacks.handleBackToQuote,
      },
    ],
    [stepsCallbacks],
  );
  const activeStep = useStepIndexFromConditions(stepsConditions);
  return { steps, activeStep, isCompleted: false };
};

export default useAvailableFactoringTutorial;
